import throttle from 'lodash/throttle';
import { LegacyRef, useEffect, useRef } from 'react';

interface UseScrollingOverflowProps {
  scrollTestSelector?: string;
}

const AFTER_CONTENT = 'after:content-[""]';

const useScrollingOverflow = ({
  scrollTestSelector,
}: UseScrollingOverflowProps): { proMenuScrollRef: LegacyRef<HTMLDivElement> } => {
  const proMenuScrollRef = useRef(null);

  useEffect(() => {
    if (!proMenuScrollRef.current) return;

    function checkOverflowStatus() {
      const proMenuElement = proMenuScrollRef.current;
      const scrollingElementToTest = scrollTestSelector
        ? proMenuElement.querySelector(scrollTestSelector)
        : proMenuElement;

      if (scrollingElementToTest.scrollHeight === scrollingElementToTest.offsetHeight) {
        proMenuElement.classList.remove(AFTER_CONTENT);
      } else {
        proMenuElement.classList.add(AFTER_CONTENT);
      }
    }

    const throttledCheckOverflowStatus = throttle(checkOverflowStatus, 100);
    checkOverflowStatus();

    window.addEventListener('resize', throttledCheckOverflowStatus, false);

    return () => {
      window.removeEventListener('resize', throttledCheckOverflowStatus, false);
    };
  }, [scrollTestSelector]);

  return {
    proMenuScrollRef,
  };
};

export default useScrollingOverflow;
